"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseOfferStepSchema = void 0;
const yup = __importStar(require("yup"));
const constants_1 = require("../constants");
const ShareStepFormSchema_1 = require("./ShareStepFormSchema");
exports.FundraiseOfferStepSchema = yup.object().shape({
    fundraiseId: yup.string().required("Please select a name"),
    calculationMethod: yup
        .string()
        .when("$isNoteRound", ([isNoteRound], schema) => !isNoteRound ? ShareStepFormSchema_1.sharePriceStepSchema.calculationMethod : schema.notRequired()),
    quantityForAmountPaid: yup
        .number()
        .when("$isNoteRound", ([isNoteRound], schema) => !isNoteRound ? ShareStepFormSchema_1.sharePriceStepSchema.quantityForAmountPaid : schema.notRequired()),
    pricePerShare: yup
        .number()
        .when("$isNoteRound", ([isNoteRound], schema) => !isNoteRound ? ShareStepFormSchema_1.sharePriceStepSchema.pricePerShare : schema.notRequired()),
    quantity: yup
        .number()
        .when("$isNoteRound", ([isNoteRound], schema) => !isNoteRound ? ShareStepFormSchema_1.sharePriceStepSchema.quantity : schema.notRequired()),
    amountPaid: yup.number().when("calculationMethod", ([calculationMethod], schema) => calculationMethod === constants_1.PRICE_PER_SHARE
        ? schema.notRequired()
        : schema
            .typeError(constants_1.AMOUNT_REQUIRED)
            .test("amountPaid", constants_1.AMOUNT_REQUIRED, (amountPaid) => amountPaid !== undefined)
            .test("amountPaid", constants_1.AMOUNT_NOT_NEG, (amountPaid) => amountPaid >= 0)
            .test("amountPaid", constants_1.AMOUNT_POSITIVE, (amountPaid) => calculationMethod !== constants_1.TOTAL_PAID_AND_PRICE_PER_UNIT || amountPaid > 0)),
});
//# sourceMappingURL=FundraiseOfferStepSchema.js.map